module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiExt.c85feb5.ttf";